(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tables.eventUpdate', {
            parent: 'tables',
            url: '/events/:eventId/update',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/tables/event/update/event.update.html',
                    controller: 'EventUpdateController',
                    controllerAs: 'vm'
                },
            },
            params: {
                "event": {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('tables.event');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
